import React, { memo, useCallback, useContext, useMemo } from 'react';
import { format } from 'date-fns';
import Spacer from 'design-system/Spacer';
import { CalendarRange } from 'design-system/calendar/CalendarRange';
import useStyles from 'hooks/useStyles';
import { formatPeriodDate } from 'utils/formatting';
import createStyleSheets from 'utils/createStyleSheets';
import { rem } from 'design-system/values';
import { minDate } from '../constants';
import { isWeb } from '../../../constants';
import { AnalyticsFilterContext } from '../context';
const CustomContent = () => {
    const styles = useStyles(styleSet);
    const { to, from, setTo, setFrom, todayDateStr } = useContext(AnalyticsFilterContext);
    const onChangeRange = useCallback((range) => {
        const fromDate = range[0] ? new Date(range[0]) : undefined;
        const toDate = range[1] ? new Date(range[1]) : undefined;
        setFrom(fromDate);
        setTo(toDate);
    }, [setFrom, setTo]);
    const title = useMemo(() => from && to
        ? formatPeriodDate({ from, to }, undefined, undefined, undefined, true, true)
        : '', [from, to]);
    const initalDates = useMemo(() => 
    // eslint-disable-next-line no-nested-ternary
    from
        ? to
            ? [format(from, 'yyyy-MM-dd'), format(to, 'yyyy-MM-dd')]
            : [format(from, 'yyyy-MM-dd')]
        : undefined, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return (<>
      <Spacer h={16}/>
      <CalendarRange fixedHeight hideDays showReset showDisabled title={title} blackMonthText unrestrictedWidth noPaddingHorizontal minDate={minDate} maxDate={todayDateStr} initialDates={initalDates} onChangeRange={onChangeRange} style={styles.calendarContainer} headerStyle={styles.headerStyle} inRangeMaskStyle={isWeb ? styles.inRangeMaskStyle : undefined}/>
      <Spacer h={16}/>
    </>);
};
export default memo(CustomContent);
const styleSet = createStyleSheets((colors) => ({
    calendarContainer: {
        maxWidth: '100%',
        backgroundColor: isWeb ? colors.background.light : colors.cards.onDark,
    },
    headerStyle: {
        paddingHorizontal: rem(11),
    },
    inRangeMaskStyle: {
        backgroundColor: colors.cards.onLight,
    },
}));
